import {formatPlural} from '@uwm/localization';
import {useSelector} from 'react-redux';

import ProgressBar from '@/components/ProgressBar/ProgressBar';
import {selectLanguageCode} from '@/state/selectors/app';
import type {PluralFormsModel} from '@/types/aem';

type BadgeProgressBarProps = {
    totalSteps: number;
    finishedSteps: number;
    actionsRemainingPluralForms?: PluralFormsModel;
    className?: string;
};

const BadgeProgressBar = ({
    totalSteps,
    finishedSteps,
    actionsRemainingPluralForms,
    className,
}: BadgeProgressBarProps) => {
    const languageCode = useSelector(selectLanguageCode);
    const remaining = totalSteps - Math.min(Math.max(finishedSteps, 0), totalSteps);
    const ariaLabel = formatPlural(remaining, actionsRemainingPluralForms, languageCode);

    return (
        <ProgressBar
            totalSteps={totalSteps}
            finishedSteps={finishedSteps}
            aria-label={ariaLabel}
            className={className}
        />
    );
};

export default BadgeProgressBar;
